import { SubscriptionName } from '@anm/api/modules/subscription';

import isTeamSubscription from '../isTeamSubscription';

const getMembersCountFromTeamName = (subscription: SubscriptionName) =>
  isTeamSubscription(subscription) && +subscription.replace('WaveTeam', '');

export default getMembersCountFromTeamName;
